import React from 'react';
import { motion } from 'framer-motion';
import { FaSchool, FaUniversity, FaTrophy } from 'react-icons/fa';
import './Education.css';

const Education = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { x: -100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: 'easeOut' }
    }
  };

  const educationData = [
    {
      icon: <FaUniversity />,
      degree: "Bachelor's in Computer Science Engineering",
      institution: 'Amrita Vishwa Vidhyapeetham',
      period: '2023 - 2027 (Expected)',
      grade: 'CGPA: 7.15/10',
      description: 'Third-year undergraduate with strong focus on full-stack development, AI/ML-based applications, and secure software engineering practices.',
      color: '#667eea'
    },
    {
      icon: <FaSchool />,
      degree: 'Class 12',
      institution: 'Velammal Vidhyashram, Surapet',
      period: '2022',
      grade: 'Higher Secondary',
      description: 'Built a strong foundation in analytical thinking and problem solving, preparing for advanced engineering studies.',
      color: '#f093fb'
    }
  ];

  return (
    <motion.div
      className="education page-transition"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="education-container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="section-title">
            My <span className="highlight">Education</span>
          </h1>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Academic background and progression
          </p>
        </motion.div>

        <motion.div
          className="timeline"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {educationData.map((edu, index) => (
            <motion.div
              key={index}
              className="timeline-item"
              variants={itemVariants}
              whileHover={{ x: 10 }}
            >
              <motion.div
                className="timeline-dot"
                style={{ borderColor: edu.color }}
                whileHover={{ scale: 1.3, rotate: 360 }}
                transition={{ duration: 0.5 }}
              >
                <div className="dot-inner" style={{ background: edu.color }}></div>
              </motion.div>

              <motion.div
                className="timeline-content"
                whileHover={{
                  boxShadow: `0 20px 60px ${edu.color}30`,
                  borderColor: edu.color
                }}
              >
                <motion.div
                  className="education-icon"
                  style={{ color: edu.color }}
                  whileHover={{ rotate: 360, scale: 1.1 }}
                  transition={{ duration: 0.6 }}
                >
                  {edu.icon}
                </motion.div>

                <div className="education-header">
                  <h3 className="degree">{edu.degree}</h3>
                  <motion.span
                    className="period"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                  >
                    {edu.period}
                  </motion.span>
                </div>

                <div className="institution-info">
                  <h4 className="institution">{edu.institution}</h4>
                  <motion.div
                    className="grade"
                    style={{ color: edu.color }}
                    whileHover={{ scale: 1.05 }}
                  >
                    <FaTrophy /> {edu.grade}
                  </motion.div>
                </div>

                <p className="description">{edu.description}</p>

                <motion.div
                  className="card-decoration"
                  style={{ background: `linear-gradient(135deg, ${edu.color}20, transparent)` }}
                  animate={{
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    duration: 5,
                    repeat: Infinity,
                    ease: 'easeInOut'
                  }}
                />
              </motion.div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="placement-ready"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.5 }}
          whileHover={{ scale: 1.02 }}
        >
          <motion.div
            className="placement-icon"
            animate={{
              rotate: [0, 10, -10, 0],
              scale: [1, 1.1, 1]
            }}
            transition={{
              duration: 3,
              repeat: Infinity
            }}
          >
            🎯
          </motion.div>
          <h3>Ready for Placements 2025</h3>
          <p>Actively seeking opportunities in Full-Stack Development with AI/ML integrations</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Education;
